import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M12.0625 18.7139V12.7139H6.0625V11.7139H12.0625V5.71387H13.0625V11.7139H19.0625V12.7139H13.0625V18.7139H12.0625Z"
        fill="#fff"
      />
    </svg>
  );
}
